export default __webpack_public_path__ + "static/media/tesla-now-3.53838b77.png";